import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import ShoppingBasket from '../audi-ui-components/icons/ShoppingBasket';
import Button from '../audi-ui-components/Button';
import TextField from '../audi-ui-components/TextField';
import Back from '../audi-ui-components/icons/Back';
import Forward from '../audi-ui-components/icons/Forward';
import CartItem from './CartItem';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.cart,
        navBarActiveIndex: state.shoppingCart.navBarActiveIndex,
        selectedGiftCardCost: state.shoppingCart.selectedGiftCardPrice,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        fetchData: ACTIONS_CREATOR.fetchData,
        updateNavBarIndex: ACTIONS_CREATOR.updateNavBarIndex,
        setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
        setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
    },
    dispatch,
);

class ShoppingCart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            discountCode: ''
        };
    }

    handleBack = () => {
        // console.log("handleBack");
        this.props.updateNavBarIndex(this.props.navBarActiveIndex - 1);
    }

    handleNext = () => {
        // console.log("handleNext");
        const {navBarActiveIndex} = this.props;
        if (navBarActiveIndex === CONST.SHOPPING_NAV_INDEX) {
            // console.log("to PersonalDetailsForm");
            this.props.updateNavBarIndex(CONST.PERSONAL_NAV_INDEX);
            this.props.history.push({pathname: `/${CONST.PATH_CART}`});
        } else if (navBarActiveIndex === CONST.PERSONAL_NAV_INDEX) {
            // to Payment
            this.props.onDetailsSubmit();
        } else if (navBarActiveIndex === CONST.PAYMENT_NAV_INDEX) {
            // to Checkout
            this.props.onPaymentSubmit();
        }
    }

    redeemCode = () => {
        const url = `/1/cart/${this.props.cart.id}/redeem`;
        const body = {code: this.state.discountCode};
        this.props.setAlertMessage(true, 'success', 'Checking code...');
        this.props.fetchData(url, 'POST', body)
            .then(result => {
                this.props.setAlertMessage(false);
                this.props.setShoppingCart(result);
                this.setState({discountCode: ''});
            })
            .catch(err => {
                err.then( errorMessage => {
                    this.props.setAlertMessage(true, 'danger', errorMessage.message);
                });
            });
    }

    removeFromCart = (itemId) => {
        // _endPoint, _method, _body, _action
        const url = `/1/cart/${this.props.cart.id}/item/${itemId}`;
        const body = {};
        this.props.setAlertMessage(true, 'success', 'Removing from cart...');
        this.props.fetchData(url, 'DELETE', body)
            .then(result => {
                this.props.setAlertMessage(false);
                this.props.setShoppingCart(result);
            })
            .catch(err => {
                err.then( errorMessage => {
                    this.props.setAlertMessage(true, 'danger', errorMessage.message);
                });
            });
    }

    get cartItems() {
        return (this.props.cart.items) ? this.props.cart.items : [];
    }

    renderBackBtn = () => {
        const {navBarActiveIndex} = this.props;
        if (navBarActiveIndex === CONST.SHOPPING_NAV_INDEX) {
            return (<Button className="ps-0" icon={<Back small />} href={CONST.NEMO_URL_PRODUCTION}>Browse other experiences</Button>);
        }
        if (navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX) {
            return (<div></div>);
        }
        return (<Button className="ps-0" icon={<Back small />} onClick={this.handleBack}>Back</Button>);
    }

    renderNextBtn = () => {
        const {navBarActiveIndex} = this.props;
        if (navBarActiveIndex === CONST.PAYMENT_NAV_INDEX) {
            return (<Button variant="primary" iconPosition="right" icon={<Forward small />} onClick={this.handleNext} disabled={this.cartItems.length === 0}>Checkout</Button>);
        }
        if (navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX) {
            return (<Button variant="primary" iconPosition="right" icon={<Forward small />} href={CONST.NEMO_URL_PRODUCTION}>Return to Audi driving experience</Button>);
        }
        return (<Button variant="primary" iconPosition="right" icon={<Forward small />} onClick={this.handleNext} disabled={this.cartItems.length === 0}>Continue</Button>);
    }

    render() {
        const {cart, navBarActiveIndex} = this.props;
        var discount = 0;
        if (cart.totalAmount !== cart.balanceAmount) {
            for (let i = 0; i < cart.payments.length; i++) {
                if (cart.payments[i].type !== 'Charge') {
                    discount += cart.payments[i].amount;
                }
            }
        }
        return (
            <section className="shopping-cart">

                {navBarActiveIndex !== CONST.CONFIRMATION_NAV_INDEX && <div className="light-border p-0">
                    <div className="cart-header d-flex flex-nowrap grey-background py-2 px-4">
                        <ShoppingBasket small />
                        <h3 className="aui-headline-4 me-auto ms-2"> Shopping Cart</h3>
                        <strong> Total Items - {this.cartItems.length}</strong>
                    </div>

                    <div className="cart-items p-4">
                        {this.cartItems.map((cartItem, index) =>
                            <CartItem item={cartItem} removeFromCart={this.removeFromCart} key={`cart_row_${index}`} />
                        )}
                    </div>

                    {this.cartItems.length > 0 && <div className="discount-code p-4">
                        <div className="row">
                            <div className="col-12 col-medium-6">
                                <div className="d-flex">
                                    <TextField name="code"
                                        floatingLabel={false}
                                        className="ade-text-box"
                                        label="Enter Code"
                                        value={this.state.discountCode}
                                        onChange={(v) => { this.setState({discountCode: v}); }} />
                                    <Button variant="primary" onClick={this.redeemCode}>Redeem</Button>
                                </div>
                                <div className="aui-textfield__description">
                                  If you have a voucher code, please enter it here and click Redeem.
                                  <br />See Gift Voucher Terms and Conditions <a href={CONST.TERMS_VOUCHER_URL} target="_blank" rel="noreferrer" className="aui-textlink">here</a>.
                                </div>
                            </div>
                        </div>
                    </div>}

                    <div className="cart-price pb-5 d-flex flex-column align-items-end">
                        {cart.totalGst > 0 && <div className="cart-gst px-4 mb-2">incl. GST ${cart.totalGst.toFixed(2)}</div>}
                        {discount > 0 && <div className="cart-gst px-4 mb-2">Discount -${discount.toFixed(2)}</div>}
                        <div className="cart-total grey-background px-4 py-2 mt-2">TOTAL ${cart.balanceAmount.toFixed(2)}</div>
                    </div>
                </div>}

                <div className="cart-footer my-4 d-flex justify-content-between">
                    {this.renderBackBtn()}
                    {this.renderNextBtn()}
                </div>

            </section>
        );
    }
}

ShoppingCart.propTypes = {
    cart: PropTypes.object,
    fetchData: PropTypes.func,
    setShoppingCart: PropTypes.func,
    setAlertMessage: PropTypes.func,
    updateNavBarIndex: PropTypes.func,
    onDetailsSubmit: PropTypes.func,
    onPaymentSubmit: PropTypes.func,
    navBarActiveIndex: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
